export const REACT_QUERY_PERSIST_KEY = "SS_ADMIN_REACT_QUERY";

export const SEASONS_LIST_LIMIT = 25;
export const SEASON_SETTINGS_SAVE_DEBOUNCE_MS = 800;

export const SUPPORTED_LANGUAGES = ["en", "de", "es", "fr"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const LOCALE_STORAGE_KEY = "ss-admin-locale";
export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export const FOOTER_LINKS = {
  contact: "https://sportradar.com/contact/",
  terms: "https://sportradar.com/imprint/",
  privacy: "https://sportradar.com/privacy-notice/",
  support: "https://support.sportradar.com/",
} as const;
